<template>
  <div class="page page-with-bg reset-password-page">
    <div class="page-form-wrap">
      <div class="page-form-header">
        <h1>Reset Password</h1>
      </div>
      <div class="page-form-content">
        <template v-if="!showSuccessConfirmation">
          <b-form @submit.prevent="submit">
            <validation-summary :errors="errors"></validation-summary>

            <v-form-group :validator="$v.email" label="Email">
              <b-form-input placeholder="Email"
                            slot-scope="{ attrs, listeners }"
                            v-bind="attrs"
                            v-on="listeners"
                            type="email"
                            v-model="email" />
            </v-form-group>

            <form-input-password v-model="password"
                                 :validator="$v.password"
                                 label="New Password">
            </form-input-password>

            <form-input-password v-model="confirmPassword"
                                 :validator="$v.confirmPassword"
                                 label="Confirm New Password">
            </form-input-password>

            <div class="form-group">
              <b-btn class="form-button" :loading="loading" variant="success" size="lg" type="submit">Reset</b-btn>
            </div>

            <div class="form-group">
              For your security, please make sure your password is:
              <ul>
                <li>at least <b>12 characters</b></li>
                <li>at least <b>1 UPPER CASE LETTER</b></li>
                <li>at least <b>1 lower case letter</b></li>
                <li>at least <b>1 number 0-9</b></li>
                <li>at least <b>1 special character !@#$%^&*()-+</b></li>
              </ul>
              If you use an Apple device, the suggested password is a perfect option!
            </div>
          </b-form>
        </template>
        <template v-else>
          <p class="text-center">Your password has been reset successfully. Please Sign In.</p>
          <b-btn variant="success" to="/login">Sign In</b-btn>
        </template>
        <b-form-group>
          <router-link to="/login">Back to Sign In</router-link>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
  import { required, email, sameAs } from "vuelidate/lib/validators";
  import { password } from "utils/custom-validators";

  import accountService from "services/account-service";
  import formMixin from "mixins/form-mixin";

  export default {
    mixins: [formMixin],

    created: function() {
      if (!this.code) this.$router.replace("/error");
    },

    props: {
      code: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        email: "",
        password: "",
        confirmPassword: "",
        showSuccessConfirmation: false
      };
    },

    validations: {
      email: {
        required,
        email
      },
      password: {
        required,
        password
      },
      confirmPassword: {
        required,
        confirmPassword: sameAs("password")
      }
    },

    methods: {
      async onSubmit() {
        let data = {
          code: this.code,
          email: this.email,
          password: this.password,
          confirmPassword: this.confirmPassword
        };

        await accountService.resetPassword(data);

        this.showSuccessConfirmation = true;
      }
    }
  };
</script>
<style scoped lang="scss">
  @import '@/styles/_mixins';

  .page {
    @include retina('/png/stethoscope.png');
  }
</style>